import { render, staticRenderFns } from "./VerDetalleMantenimientoCorrectivoModal.vue?vue&type=template&id=50145823&"
import script from "./VerDetalleMantenimientoCorrectivoModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleMantenimientoCorrectivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports